import { useEffect } from 'react'
import { useSweepstakes } from '../../contexts/SweepstakesContext'

/** Off since 22 Sep 2026 at Love & Photos' request. */
const AUTO_OPEN_FOR_NEW_VISITORS = false
import { Dialog, DialogContent, DialogClose } from '../ui/Dialog'
import SweepstakesForm from './SweepstakesForm'

/**
 * SweepstakesModal
 * Modal wrapper for the sweepstakes form
 * Auto-displays on first visit (cookie-based detection)
 */
const SweepstakesModal = () => {
  const {
    isModalOpen,
    openModal,
    closeModal,
    isFirstTimeVisitor
  } = useSweepstakes()

  // The popup no longer opens itself for new visitors (Trera, 22 Sep 2026: "the popup that is for the new visitors ...
  // they want it off"). The entry form, its steps, the email and the admin Leads page all stay; the modal still opens
  // from anything that calls openModal(). Flip AUTO_OPEN_FOR_NEW_VISITORS to bring the auto-open back.
  useEffect(() => {
    if (!AUTO_OPEN_FOR_NEW_VISITORS) return undefined
    const timer = setTimeout(() => {
      if (isFirstTimeVisitor()) {
        openModal()
      }
    }, 2000) // 2 second delay after page load

    return () => clearTimeout(timer)
  }, [isFirstTimeVisitor, openModal])

  // Fix Google Maps autocomplete z-index to appear above modal
  useEffect(() => {
    if (isModalOpen) {
      // Inject CSS to ensure Google Places autocomplete dropdown appears above modal
      const styleId = 'google-places-zindex-fix'
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style')
        style.id = styleId
        style.textContent = `
          .pac-container {
            z-index: 99999 !important;
          }
        `
        document.head.appendChild(style)
      }
    }
  }, [isModalOpen])

  return (
    <Dialog open={isModalOpen} onOpenChange={closeModal}>
      <DialogContent className="p-0 max-h-[90vh] overflow-y-auto">
        <DialogClose onClose={closeModal} />
        <SweepstakesForm />
      </DialogContent>
    </Dialog>
  )
}

export default SweepstakesModal
